import sanitize from 'sanitize-html'

export function stripHtml(s) {
  return sanitize(s, { allowedTags: [], allowedAttributes: {} })
}
